/*
 * Precision is configured per currency in cashier-admin ("Max. Amount of
 * Fraction Digits"), always in the currency's own unit. BTC is the only
 * currency the cashier also shows in sub-units. A sub-unit moves the decimal
 * point, so the same digits need fewer decimals: with 5 for BTC,
 * 0.07229 BTC = 72.29 mBTC = 72290 µBTC. Every BTC display goes through
 * toUnitFractionDigits instead of picking its own precision.
 */
type BtcDisplayUnit = "BTC" | "mBTC" | "uBTC";

/* Places the decimal point moves to the right, relative to 1 BTC. */
const BTC_UNIT_SHIFT: Record<BtcDisplayUnit, number> = {
  BTC: 0,
  mBTC: 3,
  uBTC: 6,
};

const BTC_UNIT_LABEL: Record<BtcDisplayUnit, string> = {
  BTC: "BTC",
  mBTC: "mBTC",
  uBTC: "µBTC",
};

/* The sub-unit the current user sees BTC amounts in. */
const getBtcUnit = (isUbtcEnabled = false): Exclude<BtcDisplayUnit, "BTC"> =>
  isUbtcEnabled ? "uBTC" : "mBTC";

const toUnitFractionDigits = (fractionDigits: number, unit: BtcDisplayUnit) =>
  Math.max(fractionDigits - BTC_UNIT_SHIFT[unit], 0);

export type { BtcDisplayUnit };
export { BTC_UNIT_LABEL, BTC_UNIT_SHIFT, getBtcUnit, toUnitFractionDigits };
